import React from "react";
import styled from "styled-components";
import AboutUsFold1 from "../components/AboutUsPageComponents/AboutUsFold1";
import AboutUsFold2 from "../components/AboutUsPageComponents/AboutUsFold2";

import TrackingComponent from "../components/Tracking/TrackingComponent";
import { Helmet } from "react-helmet-async";

const AboutUsPage = () => {
  return (
    <>
      <Helmet>
        <title>About appssemble | Our Story & Vision</title>
        <meta
          name="description"
          content="Founded in 2016, appssemble was born from a desire to build better software—faster and with full accountability. Learn about our founder, values, and mission."
        />
        <meta name="robots" content="index, follow" />
        <meta name="author" content="appssemble" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />

        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" />
        <meta
          property="og:title"
          content="About appssemble | Our Story & Vision"
        />
        <meta
          property="og:description"
          content="We’re not your typical software agency. appssemble builds digital solutions, not headcounts—delivering fast, scalable products with small, expert teams."
        />
        <meta property="og:url" content="https://appssemble.com/about" />
        <meta
          property="og:image"
          content="https://appssemble.com/appssemble-meta.jpeg"
        />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="About appssemble | Our Story & Vision"
        />
        <meta
          name="twitter:description"
          content="Discover how appssemble was founded, why we reject traditional outsourcing, and how our small, focused teams build better software faster."
        />
        <meta
          name="twitter:image"
          content="https://appssemble.com/appssemble-meta.jpeg"
        />

        <link rel="canonical" href="https://appssemble.com/about" />
      </Helmet>
      <Wrapper>
        <AboutUsFold1 />
        <AboutUsFold2 />
        <TrackingComponent />
      </Wrapper>
    </>
  );
};

export default AboutUsPage;
const Wrapper = styled.div`
  background: #12251a;
`;
